import request from '@/utils/request'

export const addMediaBank = data => {
  return request({
    url: '/mediaBank/addMediaBank',
    method: 'POST',
    params: data
  })
}

export const list = data => {
  return request({
    url: '/mediaBank/list',
    method: 'POST',
    params: data
  })
}

export const getMediaBankByProId = data => {
  return request({
    url: '/mediaBank/getMediaBankByProId',
    method: 'POST',
    params: data
  })
}

export const getExportMediaBankByProId = data => {
  return request({
    url: '/mediaBank/getExportMediaBankByProId',
    method: 'POST',
    params: data
  })
}
